"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _EventInfo = require("./EventInfo");
var _excluded = ["summary", "onClose"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Summary = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var summary = _ref.summary;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-primary text-white items-center justify-left text-2xl py-4 px-6 min-h-14 max-h-18 w-full truncate"
  }, summary.replace(/\\n/g, ''));
});
var ICS = /*#__PURE__*/_react["default"].memo(function (data) {
  var summary = data.summary,
    onClose = data.onClose,
    others = (0, _objectWithoutProperties2["default"])(data, _excluded);
  var handleClose = (0, _react.useCallback)(function () {
    if (onClose) {
      onClose();
    }
  }, [onClose]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: handleClose,
    className: "flex flex-col justify-center items-center h-full w-full p-10 overflow-hidden"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    className: "shadow-lg flex flex-col bg-card space-between items-left w-full max-w-2xl overflow-hidden"
  }, /*#__PURE__*/_react["default"].createElement(Summary, {
    summary: summary
  }), /*#__PURE__*/_react["default"].createElement(_EventInfo.EventDetailInfo, others)));
});
var _default = exports["default"] = ICS;
//# sourceMappingURL=ICS.js.map